import { jsx } from 'react/jsx-runtime';
import styled from 'styled-components';
import React__default from 'react';

var CenterAlignAnchor = styled.a.withConfig({
  displayName: "CenterAlignAnchor",
  componentId: "sc-eglm15-0"
})(["display:flex;width:100%;justify-content:center;"]);
var EventItemContainer = function EventItemContainer(_ref) {
  var event = _ref.event,
    hasTemplate = _ref.hasTemplate,
    DynamicWidgetRendererCreator = _ref.DynamicWidgetRendererCreator,
    onLinkClick = _ref.onLinkClick;
  var eventId = event.id;
  var hasLink = Boolean(event.link);
  var handleClick = React__default.useCallback(function (e) {
    e.preventDefault();
    e.stopPropagation();
    if (hasLink) {
      onLinkClick(event.link);
    }
  }, [event.link, hasLink, onLinkClick]);
  return jsx(CenterAlignAnchor, {
    href: "#",
    onClick: handleClick,
    children: hasTemplate && event.renderContent ? DynamicWidgetRendererCreator(event.renderContent) : jsx("div", {
      children: jsx("span", {
        style: {
          color: "white"
        },
        children: "SORRY NOT RENDER YET"
      })
    }, "event_n_".concat(eventId))
  });
};

export { EventItemContainer };
